module.exports = __webpack_public_path__ + "img/20190522110736微信截图_20190522110413.813fe683.png";